module.exports = "/_next/static/images/OgServices-ff87994566e3053d0d9dd8539253be3b.png";